import React, { useState } from 'react';
import { Button, DatePicker, Form, Modal } from 'antd';
import dayjs from 'dayjs';

import { Task } from '@totem/components/ticketing/ticketing';

type Props = {
  visible: boolean;
  task: Task;
  onCancel: () => void;
  onComplete: (newDate: string) => void;
};

const ScheduleTask = ({ visible, task, onCancel, onComplete }: Props) => {
  const [scheduledDate, setScheduledDate] = useState<string>(
    task.expectedStartDate,
  );

  const handleSubmit = () => {
    onComplete(scheduledDate);
  };

  return (
    <Modal
      open={visible}
      title="Add Task"
      onCancel={() => {
        onCancel();
      }}
      onOk={handleSubmit}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Submit
        </Button>,
      ]}
    >
      <Form.Item
        label="Scheduled Start Date"
        name="expectedStartDate"
        initialValue={dayjs(task.expectedStartDate)}
        rules={[{ required: true, message: 'Please select date' }]}
      >
        <DatePicker
          style={{ width: '100%' }}
          value={dayjs(task.expectedStartDate)}
          onChange={(newValue) => setScheduledDate(newValue.toISOString())}
        />
      </Form.Item>
    </Modal>
  );
};

export default ScheduleTask;
